<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 避難所情報の説明
  </div>
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>避難所情報の説明</span></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/shelter.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 追加ボタン
        </div>
        <div class="manual-explain">
          クリックすることで追加画面が表示されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 削除ボタン
        </div>
        <div class="manual-explain">
          クリックすることで選択した情報を削除します。<br>
          ボタンは、一覧の削除チェックボックスにチェックを入れる事で活性化されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter
        </div>
        <div class="manual-explain">
          避難所一覧に表示されているデータのフィルタリングを行います。<br>
          ※フィルタリングの対象は、避難所名、ID
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 避難所一覧
        </div>
        <div class="manual-explain">
          登録済みの避難所情報の一覧が表示されます。<br>
          編集アイコンをクリックすることで編集画面が表示されます。
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Home</a> » Shelter Information Description
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Shelter Information Description</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_shelter.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Add Button
        </div>
        <div class="manual-explain">
          Clicking this button opens the add screen.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Delete Button
        </div>
        <div class="manual-explain">
          Clicking this button deletes the selected information.<br>
          The button is enabled when the delete checkbox in the list is checked.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter
        </div>
        <div class="manual-explain">
          Filters the data displayed in the shelter list.<br>
          * Filter criteria include shelter name and ID.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Shelter List
        </div>
        <div class="manual-explain">
          Displays a list of registered shelter information.<br>
          Clicking the edit icon opens the edit screen.
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>  
</div>